export default __webpack_public_path__ + "static/media/image2.1d06c500.png";